import React from 'react'
import FunzyThankYouPage from './FunzyThankYouPage'
import SimpleThankYouPage from './SimpleThankYouPage'

const ThankYouComponents = {
  funzy: FunzyThankYouPage,
  simple: SimpleThankYouPage
}

const ThankYouPage = ({
  amount,
  application,
  child = {},
  classNames,
  donor_name: donorName,
  page_url: pageUrl,
  status
}) => {
  const ThankYouComponent = ThankYouComponents[application.thank_you_page_type]

  return (
    <ThankYouComponent
      amount={amount}
      application={application}
      child={child}
      classNames={classNames}
      donorName={donorName}
      pageUrl={pageUrl}
      status={status}
    />
  )
}

export default ThankYouPage
